import { orderedDimensions, orderedImpacts, Valence } from '@upright/common/model/types';
import { RequestStatus } from '@upright/ui/api/common/types';
import {
  DimensionDataComponentProps,
  ImpactDataComponentProps,
} from '@upright/ui/common/upright/core/impact-lenses/types';
import { flatten } from 'lodash';
import { TransitionGroup } from 'react-transition-group';
import { useCarouselContext } from '../context';

export function DataAreas() {
  const context = useCarouselContext();
  const idc = context.lens.ImpactDataComponent;
  const ddc = context.lens.DimensionDataComponent;

  const impactDataAreas = idc && renderComponentForAllImpactsAndValences(idc.component);
  const dimensionDataAreas = ddc && renderComponentForAllDimensionsAndValences(ddc.component);

  /*  Without this, part of the DataAreas show behing LensLoadingState when the component already has data but is also loading.
   * Should be fixed somehow at some point to support smooth data reloads etc., but maybe at that point also LensLoadingState should be made
   * something else than just an overlay.
   */

  if (context.data.loadingStatus === RequestStatus.LOADING) return <></>;

  // (classnames are only there for debugging convenience)
  return (
    <>
      <TransitionGroup component={'g'} className="impact-data-areas">
        {impactDataAreas}
      </TransitionGroup>
      <TransitionGroup component={'g'} className="dimension-data-areas">
        {dimensionDataAreas}
      </TransitionGroup>
    </>
  );
}

function renderComponentForAllImpactsAndValences(Component: (props: ImpactDataComponentProps) => JSX.Element) {
  const ret = orderedImpacts.map((impactCode, _index) => {
    return [
      <Component
        impact={impactCode}
        valence={Valence.NEGATIVE}
        key={impactCode.toString() + '+' + Valence.NEGATIVE.toString() + '+' + Component.name}
      />,
      <Component
        impact={impactCode}
        valence={Valence.POSITIVE}
        key={impactCode.toString() + '+' + Valence.POSITIVE.toString() + '+' + Component.name}
      />,
    ];
  });
  return flatten(ret);
}

function renderComponentForAllDimensionsAndValences(Component: (props: DimensionDataComponentProps) => JSX.Element) {
  const ret = orderedDimensions.map((dimension, _index) => {
    return [
      <Component
        dimension={dimension}
        valence={Valence.NEGATIVE}
        key={dimension.toString() + '+' + Valence.NEGATIVE.toString()}
        // "in" prop is filled automatically by TransitionGroup
      />,
      <Component
        dimension={dimension}
        valence={Valence.POSITIVE}
        key={dimension.toString() + '+' + Valence.POSITIVE.toString()}
        // "in" prop is filled automatically by TransitionGroup
      />,
    ];
  });
  return flatten(ret);
}
